import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import BanDetalization from '../BanDetalization';
import InvoiceDetalization from '../InvoiceDetalization';
import CtnDetalization from '../CtnDetalization';

const PostpaidDetalization = ({ match }) => {
  const indexUrl = `${match.path}`;
  const invoiceUrl = `${match.path}/invoice`;
  const ctnUrl = `${match.path}/ctn`;

  return (
    <Switch>
      <Route
        path={indexUrl}
        exact
        component={BanDetalization}
      />
      <Route
        path={invoiceUrl}
        component={InvoiceDetalization}
      />
      <Route
        path={ctnUrl}
        component={CtnDetalization}
      />
      <Redirect to={indexUrl} />
    </Switch>
  );
};

PostpaidDetalization.propTypes = {
  match: PropTypes.object,
};

export default PostpaidDetalization;
